import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';

const ValidatedText = ({
  required,
  defaultValue,
  name,
  label,
  disabled,
  value,
  onChange,
  inputRef,
  error,
  helperText,
  ...others
}) => {
  const [text, setText] = useState(value);
  const [modified, setModified] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  let ref = useRef();

  useEffect(() => {
    const clearErr = () => setErrorMessage('');
    const setErr = () => setErrorMessage(label + (required ? ' is required' : ' is invalid'));

    if (typeof ref === 'object' && typeof ref.addEventListener === 'function') {
      ref.removeEventListener('valid', clearErr);
      ref.addEventListener('valid', clearErr);

      ref.removeEventListener('invalid', setErr);
      ref.addEventListener('invalid', setErr);
    }
  }, [ref, label, required]);

  useEffect(() => {
    if (modified) {
      if (required && (!text || text.length === 0)) {
        setErrorMessage(label + ' is required');
      } else {
        setErrorMessage('');
      }
    }
  }, [text, label, required, modified]);

  return (
    <TextField
      required={required}
      style={{ width: '100%' }}
      size="small"
      margin="dense"
      variant="outlined"
      color="primary"
      id={name}
      name={name}
      label={label}
      className="input-field"
      error={error || !!errorMessage}
      helperText={helperText || errorMessage}
      disabled={disabled}
      {...others}
      onChange={(e) => {
        setText(e.target.value);
        setModified(true);
        onChange(e);
      }}
      value={value ?? defaultValue}
      InputLabelProps={{ shrink: !!value }}
      InputProps={{
        inputComponent: others?.InputProps?.inputComponent,
        maxLength: '100',
        inputRef: (r) => {
          if (typeof inputRef === 'function') {
            inputRef(r);
          }
          ref = r;
        },
      }}
    />
  );
};

export default ValidatedText;
